import Element from "../../element";

export default class CheckboxesInput extends Element {
	constructor(props) {
		super(props);

		this.$checkboxes = null;

		this.name = props.name || null;
		this.altDataType = props.altDataType == null ? false : true;
		this.value = null;
		this.VALUE_CHANGE_EVENT = 'valueChange';

		this.init();
	}

	init() {
		this.$root = this.props.$root;

		if (!this.$root) {
			throw new Error('CheckboxesInput: Root element is not defined!');
		}

		this.$checkboxes = this.$root.querySelectorAll('input[type="checkbox"]');

		if (this.altDataType) {
			this.value = {};

			this.$checkboxes.forEach(($checkbox) => {
				this.value[$checkbox.value] = false;
			});
		}

		super.init();
	}

	addEventListeners() {
		this.$checkboxes.forEach(($checkbox) => {
			$checkbox.addEventListener('change', (e) => {
				if ($checkbox.checked) {
					this.addValue($checkbox.value);
				} else {
					this.removeValue($checkbox.value);
				}
			});
		});
	}

	checkOption(value) {
		const $checkboxToCheck = Array.from(this.$checkboxes).find(($checkbox) => $checkbox.value === value);

		if (!$checkboxToCheck) {
			return;
		}

		$checkboxToCheck.checked = true;
		$checkboxToCheck.dispatchEvent(new Event('change'));
	}

	addValue(newValue) {
		if (this.altDataType) {
			this.value[newValue] = true;
		} else {
			if (Array.isArray(this.value)) {
				this.value.push(newValue);
			} else {
				this.value = [newValue];
			}
		}

		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}

	removeValue(value) {
		if (this.altDataType) {
			this.value[value] = false;
		} else {
			if (this.value.includes(value)) {
				this.value = this.value.filter((valueItem) => valueItem !== value);

				if (!this.value.length) {
					this.value = null;
				}
			}
		}

		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}

	uncheckAll() {
		this.$checkboxes.forEach(($checkbox) => {
			$checkbox.checked = false;
			$checkbox.removeAttribute('checked');

			if (this.altDataType) {
				this.value[$checkbox.value] = false;
			}
		});

		if (!this.altDataType) {
			this.value = null;
		}
		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}
}